import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import App from './app';
import App from './App';

// Show loading immediately while React loads
const rootElement = document.getElementById('root');
if (rootElement && !rootElement.hasChildNodes()) {
  rootElement.innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:100vh;background:#f5f5f5"><div style="width:40px;height:40px;border:4px solid #f3f3f3;border-top:4px solid #1890ff;border-radius:50%;animation:spin 0.8s linear infinite"></div><style>@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}</style></div>';
}

const root = ReactDOM.createRoot(rootElement);

// Remove StrictMode in production for better performance
// StrictMode causes double renders in development which is fine for debugging
const AppWrapper = process.env.NODE_ENV === 'production'
  ? <App />
  : <React.StrictMode><App /></React.StrictMode>;

root.render(AppWrapper);


